<template>
  <div>
    <div class="row mt-0">
      <div class="col-12 col-md-6 col-lg-4">
        <atom-input
          v-model="parcelTrackingFilter.idcId"
          :title="contractIdLabel"
          :placeholder="contractIdLabel"
          type="number"
          :maxLength="8"
        ></atom-input>
      </div>
      <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
        <atom-input
          v-model="parcelTrackingFilter.customerName"
          title="Customer Name"
          placeholder="Customer Name"
        ></atom-input>
      </div>
      <div class="col-12 col-lg-4 mt-1 mt-lg-0">
        <atom-select
          v-model="parcelTrackingFilter.status"
          title="Status"
          placeholder="All Status"
          label="name"
          :option="parcelTrackingStatusOption"
        ></atom-select>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12 col-lg-4">
        <atom-select
          v-model="parcelTrackingFilter.type"
          title="Date Type"
          placeholder="Select Date Type"
          label="name"
          :isClearable="false"
          :option="parcelTrackingDataTypeOption"
        ></atom-select>
      </div>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import mixins from '@/mixins'

export default {
  name: "MoleculeReportFilterParcelTracking",
  components: { AtomSelect, AtomInput },
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      required: true,
    },
    parcelTrackingStatusOption: {
      type: Array,
      required: true,
    },
    parcelTrackingDataTypeOption: {
      type: Array,
      required: true,
    },
  },

  computed: {
    parcelTrackingFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style></style>
